import { Component, ComponentChildren, h } from 'preact'
import StatelessPanel from './StatelessPanel'

interface PanelProps {
  heading?: string,
  body?: ComponentChildren,
  title?: ComponentChildren,
  hasUnsavedChanges?: boolean,
  customClass?: string,
  onClick?: () => void
}

interface Props {
  panels?: Array<PanelProps>,
  defaultActivePanelIndex?: number,
  renderUnsavedChangesModal?:() => void
}

interface State {
  activePanelIndex?: number
}

class AccordionPanel extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      activePanelIndex: this.props.defaultActivePanelIndex ?? undefined
    }
    this.togglePanel = this.togglePanel.bind(this)
  }

  togglePanel (activeIndex: number, showUnsavedMessage: boolean = false) {
    if (showUnsavedMessage && this.props.renderUnsavedChangesModal) {
      this.props.renderUnsavedChangesModal()
      return
    }
    if (this.state.activePanelIndex === activeIndex) {
      this.setState({ activePanelIndex: undefined })
      return
    }

    this.setState({ activePanelIndex: activeIndex })
  }

  componentDidUpdate (previousProps: Props) {
    if (previousProps.defaultActivePanelIndex !== this.props.defaultActivePanelIndex) {
      this.setState({ activePanelIndex: this.props.defaultActivePanelIndex })
    }
  }

  render ({ panels }: Props, { activePanelIndex }: State) {
    if (!Array.isArray(panels)) return null

    return (
      <div> {panels.map((panelChild, idx) => {
        let showUnsavedMessage = panelChild.hasUnsavedChanges ?? false
        let customClass = panelChild.customClass ?? ''
        return (<StatelessPanel
          title={panelChild.title}
          newStyle
          collapsible
          isOpen={activePanelIndex === idx}
          customTogglePanel={() => {
            this.togglePanel(idx, showUnsavedMessage)
            if (panelChild.onClick) panelChild.onClick()
          }}
          bodyClass={customClass}
          customClass={customClass}
          heading={panelChild.heading}>
          {panelChild.body}
        </StatelessPanel>)
      }) }</div>)
  }
}

export default AccordionPanel
